import React from 'react';
import stylesFaq from '../faq/Faq.module.css';

function Termini(props) {
    return (
        <div className={stylesFaq.marginInitial}>
            <div className={"Container ".concat(stylesFaq.fontStylePage)}>

                {/* Sezione 1: Proprietà e titolarità del portale */}
                <p className={stylesFaq.fontStyleElement}>Proprietà e titolarità del portale</p>
                <p>Il presente portale è di proprietà della Regione del Veneto - Giunta Regionale.</p>
                <p>Azienda Zero ne cura la gestione tecnica, informatica e operativa.</p>

                {/* Sezione 2: Limitazioni di responsabilità */}
                <div className={stylesFaq.marginElement}>
                    <p className={stylesFaq.fontStyleElement}>Limitazioni di responsabilità</p>
                    <p>Eventuali malfunzionamenti tecnici non danno diritto a risarcimenti.</p>
                    <p>I collegamenti a siti esterni non implicano alcuna responsabilità in capo agli enti gestori.</p>
                </div>

                {/* Sezione 3: Termini d'uso del servizio */}
                <div className={stylesFaq.marginElement}>
                    <p className={stylesFaq.fontStyleElement}>Termini d'uso del servizio</p>
                    <p>In applicazione della Legge Regionale del 17 ottobre 2017, n. 38, della D.G.R. del 28 giugno 2019, n. 910 e della D.G.R. del 30 aprile 2026, n. 319, è stata creata la presente piattaforma con lo scopo di agevolare l'incontro tra la domanda e l'offerta di lavoro nel settore dell'assistenza familiare.</p>
                    <p>La piattaforma si integra con i servizi per l'impiego regionali e con i servizi sociali dei Comuni veneti.</p>
                    <p>Si precisa che Regione del Veneto non interviene nella stipula di contratti di lavoro né nella gestione dei relativi pagamenti.</p>
                    <p>È responsabilità esclusiva degli utenti garantire la veridicità e la correttezza di tutte le informazioni inserite nel sistema.</p>
                </div>

            </div>
        </div>
    );
}

export default Termini;
